import RandExp from 'randexp';

interface RequestsToken {
 Authorization: string
}

export const generateId = (): string => {
  const regex = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;

  return new RandExp(regex).gen();
};
